import { API, graphqlOperation } from "aws-amplify";

const exportTransactionMutation = `
  mutation ExportTransaction(
    $body: ExportTransactionInput!
  ){
    exportTransaction(body: $body){
      success
      messageId
      errorMessage
    }
  }
`;

export default {
  methods: {
    async exportOperation(exportDetails) {
      try {
        let exportTransactionInput = {
          emailList: exportDetails.emailList,
          criteria: exportDetails.criteria,
          bankGlobalNameNumber: exportDetails.bankGlobalNameNumber,
          criteriaInfo: exportDetails.criteriaInfo
        };

        const exportResponse = await API.graphql(
          graphqlOperation(exportTransactionMutation, {
            body: exportTransactionInput
          })
        );

        if (exportResponse.data.exportTransaction) {
          return exportResponse.data.exportTransaction;
        }
        return false;
      } catch (err) {
        this.$logger.error(err);
      }
    }
  }
};
